import { render, staticRenderFns } from "./RealityUpgradeButton.vue?vue&type=template&id=e8435e5a&scoped=true&"
import script from "./RealityUpgradeButton.vue?vue&type=script&lang=js&"
export * from "./RealityUpgradeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8435e5a",
  null
  
)

export default component.exports